export const paginationI18NDe = {
    prev: "Vorige",
    next: "Nächste",
    of: "von",
};
